import { render, staticRenderFns } from "./OldChecklistChooseTemplatePage.vue?vue&type=template&id=fd7a26b6&"
import script from "./OldChecklistChooseTemplatePage.vue?vue&type=script&lang=ts&"
export * from "./OldChecklistChooseTemplatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports